import type {YoutubeSubscribeTriggerStruct} from '@cohort/shared/apps/youtube/triggers/subscribe';
import type {ActionCtaComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import OpenCtaWithRefresh from '@cohort/wallet/components/challenges/OpenCtaWithRefresh';
import {useTranslation} from 'react-i18next';

const YoutubeSubscribeTriggerActionCtaComponent: React.FC<
  ActionCtaComponentProps<YoutubeSubscribeTriggerStruct>
> = ({config, trackingMetadata, stepId, processStepVerification}) => {
  const {t} = useTranslation('app-youtube', {
    keyPrefix: 'triggerIntegrations.subscribe',
  });

  return (
    <OpenCtaWithRefresh
      url={config.channelUrl}
      stepId={stepId}
      processStepVerification={processStepVerification}
      trackingMetadata={trackingMetadata}
      ctaTitle={t('ctaTitle')}
      refreshCtaTitle={t('refreshTitle')}
    />
  );
};

export default YoutubeSubscribeTriggerActionCtaComponent;
